<script setup>
import {useSystem} from "../../store/system";
import {onActivated, onMounted, reactive, ref} from "vue";
import {ElMessage} from "element-plus";

const systemStore = useSystem()

const validateEmail = (email) => {
  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

const submitLoading = ref(false)
const formData = reactive({
  nickname: '',
  title: '',
  email: '',
  content: '',
  phone: ''
})
const submitForm = () => {
  if (!formData.nickname) {
    ElMessage({
      duration: 1500,
      message: "Name cannot be empty",
      type: 'error',
      onClose: () => {}
    })
    return
  }
  if (!formData.title) {
    ElMessage({
      duration: 1500,
      message: "Subject cannot be empty",
      type: 'error',
      onClose: () => {}
    })
    return
  }
  if (!formData.email) {
    ElMessage({
      duration: 1500,
      message: "Email cannot be empty",
      type: 'error',
      onClose: () => {}
    })
    return
  }
  if (!validateEmail(formData.email)) {
    ElMessage({
      duration: 1500,
      message: "Email Invalid",
      type: 'error',
      onClose: () => {}
    })
    return
  }
  if (!formData.content) {
    ElMessage({
      duration: 1500,
      message: "Message cannot be empty",
      type: 'error',
      onClose: () => {}
    })
    return
  }
  submitLoading.value = true

  systemStore.contactsUsApi(formData)

  formData.nickname = ''
  formData.title = ''
  formData.email = ''
  formData.content = ''
  formData.phone = ''

  setTimeout(() => {
    submitLoading.value = false
  }, 500)
}

onMounted(() => {
  setTimeout(() => {
    // 动态雾霾效果
    if (document.querySelector('.section__canvas--first')) {
      VANTA.FOG({
        el: "#canvas",
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.00,
        minWidth: 200.00,
        highlightColor: 0xA034FA,
        midtoneColor: 0xA034FA,
        lowlightColor: 0xE66C12,
        baseColor: 0x16142A,
        blurFactor: 0.90,
        speed: 5.70,
        zoom: 1.00
      })
    }
  }, 500)

})

onActivated(() => {
  document.title = 'Cloud Mining FAQs | HexMiner Support & Solutions';
  document.querySelector('meta[name="description"]').setAttribute('content', 'Get answers about Bitcoin mining without hardware, free\n' +
      'trials, and high ROI strategies. HexMiner’s expert guidance here!');
})
</script>

<template>

  <!-- about -->
  <div class="section section--head">
    <div class="container">
      <div class="row row--relative">
        <div class="col-12">
          <div class="about">
            <h2 class="about__title">{{systemStore.getFrontModuleContent(17, 1)?.title}}</h2>

            <p class="about__text">{{systemStore.getFrontModuleContent(17, 1)?.description}}</p>
            <!-- design elements -->
            <span class="block-icon block-icon--purple">
							<i class="ti ti-binary"></i>
						</span>
            <span class="screw screw--lines-bl"></span>
            <span class="screw screw--lines-br"></span>
            <span class="screw screw--lines-tr"></span>
          </div>
        </div>

        <!-- animation background -->
        <div class="section__canvas section__canvas--page section__canvas--first" id="canvas2"></div>
      </div>
    </div>
  </div>
  <!-- end about -->

  <!-- faq -->
  <section class="section section--head tw-mt-0">
    <div class="container">
      <div class="row">
        <!-- title -->
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2">
          <div class="section__title">
            <h2>{{systemStore.getFrontModuleContent(6)?.title}}</h2>
            <p>{{systemStore.getFrontModuleContent(6)?.sub_title}}</p>
          </div>
        </div>
        <!-- end title -->
      </div>

      <div class="row">
        <!-- tabs content -->
        <div class="col-12">
          <div class="tab-content">
            <div class="tab-pane fade show active" id="tab-1" role="tabpanel">
              <div class="row">
                <!-- accordion -->
                <div class="col-12">
                  <div class="accordion" id="accordion">
                    <div class="row">
                      <div class="col-12 col-lg-6" v-for="(item, index) in systemStore.getFrontModuleContent(6)?.json_data" :key="index">
                        <div class="accordion__card">
                          <button class="collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse'+index" aria-expanded="false" :aria-controls="'collapse'+index">{{item.title}}</button>

                          <div :id="'collapse'+index" class="collapse visible" data-bs-parent="#accordion">
                            <p>{{item.desc}}</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <!-- end accordion -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- end faq -->

  <div>
    <!-- head -->
    <div class="section section--head tw-pt-0">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-6 offset-md-3 col-xl-4 offset-xl-4">
            <div class="section__title">
              <h1>{{systemStore.getFrontModuleContent(20).title}}</h1>
              <p>{{systemStore.getFrontModuleContent(20).sub_title}}</p>
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- contact from -->
    <div class="section">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12">
            <form class="form" action="#">
              <div class="row">
                <div class="col-12 col-md-6 col-xl-3">
                  <div class="form__group">
                    <label for="name" class="form__label">Name</label>
                    <input id="name" type="text" v-model="formData.nickname" class="form__input" placeholder="Full name">
                  </div>
                </div>

                <div class="col-12 col-md-6 col-xl-3">
                  <div class="form__group">
                    <label for="mail" class="form__label">Email</label>
                    <input id="mail" type="email" v-model="formData.email" class="form__input" placeholder="example@domain.com">
                  </div>
                </div>

                <div class="col-12 col-md-6 col-xl-3">
                  <div class="form__group">
                    <label for="phone" class="form__label">Phone</label>
                    <input id="phone" type="text" v-model="formData.phone" class="form__input" placeholder="800 543 - 2109">
                  </div>
                </div>

                <div class="col-12 col-md-6 col-xl-3">
                  <div class="form__group">
                    <label for="subject" class="form__label">Subject</label>
                    <input id="subject" type="text" v-model="formData.title" class="form__input" placeholder="Ex. Support">
                  </div>
                </div>

                <div class="col-12">
                  <div class="form__group">
                    <label for="message" class="form__label">Message</label>
                    <textarea id="message" v-model="formData.content" class="form__textarea" placeholder="Please enter your message..."></textarea>
                  </div>
                </div>

                <div class="col-12">
                  <el-button :loading="submitLoading" class="section__btn justify-self-left" native-type="button" @click="submitForm"> {{submitLoading? 'Submitting ...': 'Submit'}}</el-button>
                  <!--                  <button type="button" class="form__btn form__btn&#45;&#45;small" @click="submitForm">Submit</button>-->
                </div>
              </div>

              <!-- design elements -->
              <span class="block-icon block-icon--purple">
							<i class="ti ti-mail-up"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </form>
          </div>

          <!-- animation background -->
          <div class="section__canvas section__canvas--page section__canvas--first" id="canvas"></div>
        </div>
      </div>
    </div>
    <!-- end contact from -->

  </div>

</template>

<style scoped>

</style>
